import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-12 px-6">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div>
          We make software.
        </div>
        <div>
          <a 
            href="mailto:hello@veipha.com" 
            className="hover:text-pink-400 transition-colors style={{fontFamily: 'Space Grotesk, sans-serif'}}"
          >
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
